import { render, staticRenderFns } from "./tsyj.vue?vue&type=template&id=280de21e&scoped=true&"
import script from "./tsyj.vue?vue&type=script&lang=js&"
export * from "./tsyj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280de21e",
  null
  
)

export default component.exports